import React, {FC} from 'react';

import {globalWindow} from '../../../../../libs/shared/core/src/helpers/browser/browserHelpers';
import {useInitialEffect} from '../../../../../libs/shared/core/src/helpers/react/hooks/useEffectHelpers';
import {IntegrationErrorModel} from '../../../../models/api/integrationErrorModel';
import {IntegrationErrorBannerContainer} from './integrationErrorBannerContainer';

/*
 * Props.
 */

interface IntegrationErrorBannersProps {
  errors: ReadonlyArray<IntegrationErrorModel>;
  onMount: () => void;
}

/*
 * Component.
 */

export const IntegrationErrorBanners: FC<IntegrationErrorBannersProps> = (props) => {
  useInitialEffect(() => {
    const timeout = globalWindow.setInstrumentedTimeout(props.onMount, 10000);
    return () => globalWindow.clearTimeout(timeout);
  });

  return (
    <>
      {props.errors.map((error) => (
        <IntegrationErrorBannerContainer key={error.id} error={error} />
      ))}
    </>
  );
};
